export default __webpack_public_path__ + "static/media/ic_more.8cc552bc.svg";